/* jshint esversion: 6, -W097 */
/* globals require, module */
'use strict';
/**
 * Module that holds the balanced grid/column directive for both cars and appliance marketplaces.
 */

const balancedColumnsDirective = require('./balancedColumnsDirective');

const balancedColumnsModule = angular
    .module('enervee_utils.balanced_columns', [])
    .directive('balancedColumns', balancedColumnsDirective);

module.exports = balancedColumnsModule;